import { View, Text, TouchableOpacity, StyleSheet } from "react-native";
import React, { useCallback, useMemo, useState } from "react";

import { doc, updateDoc } from "firebase/firestore";
import db from "../Firestore/FirestoreConfig";

import { Entypo } from "@expo/vector-icons";

import Fonts from "../../Resources/Fonts";
import GlobalStyles from "../../Resources/Styles";
import Colors from "../../Resources/Color";
import { observer } from "mobx-react";
import FloatingMenu from "../Components/FloatingMenu";
import Block from "../Firestore/Block";
import Workout from "../Firestore/Workout";
import Exercise from "../Firestore/Exercise";
import Serie from "../Firestore/Serie";
import Attribute from "../Firestore/Attribute";
import AddBlockView from "./AddBlockView";

import { Ionicons } from "@expo/vector-icons";
import { FontAwesome5 } from "@expo/vector-icons";
import CopyBlockToClient from "./CopyBlockToClient";

import CustomAlert from "../Components/CustomAlert";
import { useScreenDimensions, useDevice } from "../_layout";

import DeleteBlockView from "./DeleteBlockView";

import { useTranslation } from "react-i18next";
import { useToast } from "../contexts/ToastContext";
import HoverableTouchableOpacity from "../Components/HoverableTouchableOpacity";

const BlockRowView = observer(({ block, labelIdx, idx }) => {
  const { t } = useTranslation();
  const { isMobile } = useDevice();
  const { showToast } = useToast();

  const [showingChangeBlockName, setShowingChangeBlockName] = useState(false);
  const [showingCopyToClient, setShowingCopyToClient] = useState(false);
  // const [showingCopyToLibrary, setShowingCopyToLibrary] = useState(false);
  const [showingDeleteAlert, setShowingDeleteAlert] = useState(false);
  const deleteAlertTitle = "deleteBlockAlertTitle-string";
  const deleteAlertText = "deleteBlockAlertText-string";
  const [isHovered, setIsHovered] = useState(false);
  const [isMenuHovered, setIsMenuHovered] = useState(false);
  const [isArrowHovered, setIsArrowHovered] = useState(false);
  const { screenSize } = useScreenDimensions();

  const showCopyToClient = () => {
    setShowingCopyToClient(true);
  };

  // const showCopyToLibrary = () => {
  //   setShowingCopyToLibrary(true);
  //   setBlockMenu(false);
  // };

  const addToLibrary = () => {
    block.copyBlockToLibrary(showToast);
  };

  const showDeleteAlert = () => {
    setShowingDeleteAlert(true);
  };

  const deleteBlock = () => {
    block.client.deleteBlock(block);
    setShowingDeleteAlert(false);
  };

  const blockMenuItems = useMemo(
    () => [
      {
        key: "editBlock",
        label: t("editBlock-string"),
        icon: { type: "ionicons", name: "create-outline" },
      },
      {
        key: "copyBlock",
        label: t("copyBlock-string"),
        icon: { type: "ionicons", name: "duplicate-outline" },
      },
      {
        key: "copyFullBlock",
        label: t("copyFullBlock-string"),
        icon: { type: "ionicons", name: "duplicate-outline" },
      },
      {
        key: "copyToClient",
        label: t("copyToAnotherClient-string"),
        icon: { type: "ionicons", name: "person-add-outline" },
      },
      {
        key: "exportToLibrary",
        label: t("exportToLibrary-string"),
        icon: { type: "ionicons", name: "book-outline" },
      },
      {
        key: "delete",
        label: t("delete-string"),
        icon: { type: "ionicons", name: "trash-outline" },
        isDanger: true,
      },
    ],
    [t]
  );

  const handleBlockMenuAction = useCallback(
    (itemKey) => {
      if (itemKey === "editBlock") {
        block.client.setSelectedBlock(block);
        block.setProperty("isShowingDashboard", true);
        return;
      }

      if (itemKey === "copyBlock") {
        const newBlock = block.client.copyBlock(
          t,
          block,
          false,
          undefined,
          showToast
        );
        block.client.updateClientTransactionData(newBlock.id);
        block.client.startOrResetBatchTimer();
        return;
      }

      if (itemKey === "copyFullBlock") {
        const newBlock = block.client.copyBlock(
          t,
          block,
          true,
          undefined,
          showToast
        );
        block.client.updateClientTransactionData(newBlock.id);
        block.client.startOrResetBatchTimer();
        return;
      }

      if (itemKey === "copyToClient") {
        showCopyToClient();
        return;
      }

      if (itemKey === "exportToLibrary") {
        addToLibrary();
        return;
      }

      if (itemKey === "delete") {
        showDeleteAlert();
      }
    },
    [addToLibrary, block, showCopyToClient, showDeleteAlert, showToast, t]
  );

  return (
    <View
      style={{
        flexDirection: "row",
        alignItems: "center",
        marginBottom: 10,
        maxWidth: screenSize != "medium" ? "100%" : "50%",
        marginTop:
          block.label === "" ? (labelIdx !== 0 && idx === 0 ? 20 : 0) : 0,
      }}
    >
      <TouchableOpacity
        onPress={() =>
          !showingChangeBlockName && block.client.setSelectedBlock(block)
        }
        style={[
          GlobalStyles.touchableRow,
          {
            // flex: 1,
            borderWidth: block.isActive ? 1 : 0.1,
            borderColor: block.isActive
              ? Colors.blackColor
              : isHovered
              ? "rgba(0, 0, 0, 0.5)"
              : "rgba(0, 0, 0, 0.1)",
            width: screenSize != "large" ? "auto" : "80%",
            marginBottom: 0,
            flex: 1,
          },
        ]}
        onMouseEnter={() => !isMobile && setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <View style={{ alignItems: "flex-start", flex: 1 }}>
          <Text
            numberOfLines={2}
            style={[Fonts.medium14, { marginBottom: 8, fontWeight: "500" }]}
          >
            {block.name}
          </Text>
          <View style={[GlobalStyles.HStack, { maxWidth: "110%" }]}>
            {/* <FontAwesome5
            name="clipboard-list"
            size={13}
            color={Colors.bubbleColor}
            style={{ paddingRight: 5 }}
          /> */}
            {block.isActive && (
              <Text
                style={{
                  marginRight: 10,
                  fontSize: 12,
                  color: Colors.grayColor,
                }}
              >
                {t("active-string")}
              </Text>
            )}
            <Ionicons
              name="calendar"
              size={12}
              color={Colors.bubbleColor}
              style={GlobalStyles.rowIcon}
            />
            <Text
              style={{ ...GlobalStyles.rowSubText, marginRight: 0 }}
              numberOfLines={1}
            >
              {t("clientWeekStatus-string", {
                blockCurrentWeek: block.getWeeks,
                blockWeeks: block.totalWeeks,
              })}
            </Text>
          </View>
        </View>

        <FloatingMenu
          placement="bottom-end"
          width={220}
          items={blockMenuItems}
          trigger={
            <View
              onMouseEnter={() => !isMobile && setIsMenuHovered(true)}
              onMouseLeave={() => setIsMenuHovered(false)}
            >
              <Entypo
                name="dots-three-horizontal"
                size={22}
                color="black"
                style={{
                  opacity: isMenuHovered ? 0.6 : 1,
                  ...GlobalStyles.rowThreeDots,
                }}
              />
            </View>
          }
          renderItem={({ item, close }) => (
            <HoverableTouchableOpacity
              style={styles.blockMenuItemRow}
              hoverStyle={styles.blockMenuItemHover}
              onPress={(e) => {
                e?.stopPropagation?.();
                handleBlockMenuAction(item.key);
                close();
              }}
              title={item.label}
            >
              {item?.icon?.type === "ionicons" ? (
                <Ionicons
                  name={item.icon.name}
                  size={14}
                  color={item.isDanger ? Colors.redColor : Colors.darkgrayColor}
                />
              ) : null}
              <Text
                style={[
                  styles.blockMenuItemText,
                  item.isDanger ? styles.blockMenuItemDanger : null,
                ]}
              >
                {item.label}
              </Text>
            </HoverableTouchableOpacity>
          )}
        />
      </TouchableOpacity>
      <TouchableOpacity
        onPress={() => block.client.setShownBlock(block)}
        onMouseEnter={() => !isMobile && setIsArrowHovered(true)}
        onMouseLeave={() => setIsArrowHovered(false)}
      >
        <Ionicons
          name={
            block.isShown
              ? "arrow-forward-circle"
              : "arrow-forward-circle-outline"
          }
          size={24}
          color="black"
          style={{
            paddingVertical: 10,
            marginLeft: screenSize === "small" ? 8 : 16,
            marginRight: screenSize === "large" ? 16 : 0,
            opacity: isArrowHovered ? 0.5 : 1,
          }}
        />
      </TouchableOpacity>
      {showingChangeBlockName && (
        <AddBlockView
          isVisible={showingChangeBlockName}
          onClose={() => setShowingChangeBlockName(false)}
          block={block}
          client={block.client}
        />
      )}
      {showingCopyToClient && (
        <CopyBlockToClient
          isVisible={showingCopyToClient}
          onClose={() => setShowingCopyToClient(false)}
          block={block}
        />
      )}

      {showingDeleteAlert && (
        <DeleteBlockView
          isVisible={showingDeleteAlert}
          onClose={() => setShowingDeleteAlert(false)}
          title={deleteAlertTitle}
          text={deleteAlertText}
          action={deleteBlock}
          nameOfBlock={block ? block.name : ""}
        />
      )}
    </View>
  );
});

const styles = StyleSheet.create({
  blockMenuItemRow: {
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
    paddingVertical: 10,
    paddingHorizontal: 10,
    borderRadius: 8,
  },
  blockMenuItemHover: {
    backgroundColor: Colors.hoveredGray,
  },
  blockMenuItemText: {
    fontSize: 12,
    color: Colors.blackColor,
    fontWeight: "500",
  },
  blockMenuItemDanger: {
    color: Colors.redColor,
  },
});

export default BlockRowView;
